import { createStore } from 'redux';

// Define an initial state
const initialState = {
    selectedFilters: [],
    filterOptions : null,
    activeCheckList : null,
    mapParkData : [], 
    filterObjectData: null ,
    searchPinAppending : false,
    developmentFilters: null,
    isShowTimer : false,
    viewPort:{ width: "100%",
    height: "100vh",
    longitude: -109.4293977,
    latitude: 47.0721469,
    zoom: 2.7,
    cursor: "pointer",
    activeTileSet : null,
    isMarketCenterAvailable : false,
    initialFilterIds : [],
    showStorePins : true,
    filterbyOptions:[],
    isTrafficReset:false,
    userDetails:null,
    isTrafficReset:false,
    userDetails:null
  },
   isDemomarket:false,
    InfoPopup:true,
   
};
   
   



// Define a reducer function
const counterReducer = (state = initialState, action) => {

  if (action.type === 'RESET_APP_STATE') {
    return initialState; // 🔁 Reset to default state
  }
  if(action.type === "RESET_MAP_OVERLAYS_STATE"){
    return {...state,
    activeTileSet : null,
    isMarketCenterAvailable : false,
    initialFilterIds : [],
    showStorePins : true,
    filterbyOptions:[] }
  }
  
  switch (action.type) {
    case 'selectedFilters':
      return { ...state, selectedFilters:  action.value};
    case 'filterOptions':
    return { ...state, filterOptions : action.value};
    case 'activeCheckList':
      return { ...state, activeCheckList : action.value};
    case 'mapParkData':
      return { ...state , mapParkData : action.value}
    case 'filterObjectData':
        return { ...state , filterObjectData : action.value}     
    case 'searchPinAppending':
        return { ...state , searchPinAppending : action.value}  
    case 'developmentFilters':
      return {...state,developmentFilters:  action.value ? [...action.value] : action.value}
      case "isShowTimer" :
        return {...state , isShowTimer : action.value}
          case "activeTileSet":
            return{...state,activeTileSet:action.value}
          case "viewPort":
            return{...state,viewPort:action.value}
            case "isMarketCenterAvailable":
              return {...state,isMarketCenterAvailable:action.value}
              case "initialFilterIds":
               return {...state,initialFilterIds:action.value}
                case "showStorePins":
                  return {...state,showStorePins:action.value}
                    case "filterbyOptions":
                      return {...state,filterbyOptions:action.value}
                        case "isTrafficReset":
                          return {...state,isTrafficReset:action.value}
                        case 'IsDemoMarket':
          return {...state,isDemomarket:action.value}
          case 'InfoPopup':
            return {...state,InfoPopup:action.value}
            case 'userDetails':
              return { ...state, userDetails : action.value};  
    default:
      return state;

  }
};
// Create a Redux store using the reducer
const store = createStore(counterReducer);
export default store;